import servise from '@/router/axios'

export const addplot = (data) => {
  return servise({
    url: '/slot/add/slot/plan',
    method: 'post',
    data
  })
}

export const upDataPlot = (data) => {
  return servise({
    url: '/slot/update/slot/plan',
    method: 'PUT',
    data
  })
}
export const getdataplot = (params) => {
  return servise({
    url: '/slot/one/slot/plan',
    method: 'get',
    params
  })
}
export const upstataplot = (data) => {
    return servise({
      url: '/slot/update/plan/state',
      method: 'PUT',
      data
    })
  }

  export const selectData = (params) => {
    return servise({
      url: '/slot/dsp/not/where/slot/dsp',
      method: 'get',
      params
    })
  }
  export const selectDsp = (params) => {
    return servise({
      url: '/user/dsp/getSingleDsp',
      method: 'get',
      params
    })
  }

export const getBrand = (params) => {
  return servise({
    url: '/brandModel/get/brand/model',
    method: 'get',
    params
  })
}